/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CartService } from "src/app/services/cart/cart.service";
import { StoresService } from "src/app/services/catalog/stores.service";
import { GeoCodeService } from "src/app/services/common/geocode/geo-code.service";
import { DialogService } from "src/app/services/dialog-service/dialog.service";
import { BusinessUnitsApiService } from "src/app/services/my-company/business-units/business-units-api.service";
import { RegisterStoreApiService } from "src/app/services/register-store/register-store-api.service";
import { RegexService } from "src/app/services/shared/regex/regex.service";
import { SlotService } from "src/app/services/slot/slot.service";
import {
  icons,
  isPatricianFlag,
  isSRSMFlag,
  storeText,
} from "src/environments/config";
import { UserService } from "valuchaincommon/common-services/user/user.service";
import { LocalStorageService } from ".././../../services/shared/local-storage/local-storage.service";
import { RegisterStoreComponent } from "../register-store/register-store.component";
import { WhiteshopForgotPasswordComponent } from "../whiteshop-forgot-password/whiteshop-forgot-password.component";

@Component({
  selector: "app-whiteshop-login",
  templateUrl: "./whiteshop-login.component.html",
  styleUrls: ["./whiteshop-login.component.scss"],
})
export class WhiteshopLoginComponent implements OnInit {
  passwordType = "password";
  passwordVisibility = false;
  passwordImg = icons.whiteShopIcon.eyeSlash;
  public whiteShopIcon = icons.whiteShopIcon.icon;
  storeText = storeText.text;
  isClicked = false;
  isClosed = true;
  showRegister = true;
  hideregisterURLs = [
    "https://srsm.shopconnect.live",
    "https://www.srshoppingmall.com",
    "https://goldenthreadssales.shopconnect.live",
    "https://goldenthreads.shopconnect.live",
    "https://beaulysales.shopconnect.live",
    "https://beauly.shopconnect.live",
    "https://ffsales.shopconnect.live",
    "https://farmersfresh.shopconnect.live",
    "https://thehappybabystore.shopconnect.live",
    "https://thehappybabystoresales.shopconnect.live",
    "https://happybabystore.in",
    "https://sales.happybabystore.in",
    "https://ridhimehra.shopconnect.live",
    "https://ridhimehrasales.shopconnect.live",
    "https://rmsales.shopconnect.live",
    "https://nidhissales.shopconnect.live",
  ];
  @ViewChild("passwordField") passwordField: ElementRef;

  constructor(
    public dialogService: DialogService,
    public router: Router,
    public registerStoreApiService: RegisterStoreApiService,
    public localStorageService: LocalStorageService,
    public toastrService: ToastrService,
    public regexService: RegexService,
    public formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<WhiteshopLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public slotService: SlotService,
    public cartService: CartService,
    public storesService: StoresService,
    public businessUnitService: BusinessUnitsApiService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    public valuChainUserService: UserService,
    public geoCodeService: GeoCodeService
  ) {
    this.iconRegistry.addSvgIcon(
      "arrow_back",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/arrowBackBlack.svg"
      )
    );
  }
  public userLoginForm = this.formBuilder.group({
    username: ["", Validators.required],
    password: ["", [Validators.minLength(8), Validators.required]],
  });
  ngOnInit(): void {
    // Register option is disabled for highline,jdx,srsm,ffsales,happybaby,hbssales URLs.So, Register option will be hidden in above URLs'
    if (
      this.hideregisterURLs.findIndex(
        (eachURL) => eachURL === window.location.origin
      ) > -1
    ) {
      this.showRegister = false;
    }
    this.localStorageService.isLogoUpdated.subscribe((data) => {
      if (data && data.length) {
        this.whiteShopIcon = data[0];
      }
    });
  }

  signIn() {
    if (this.userLoginForm.valid && this.validUsername()) {
      this.isClicked = true;
      this.registerStoreApiService
        .storeLogin(
          this.userLoginForm.value,
          isSRSMFlag.flag,
          isPatricianFlag.flag
        )
        .subscribe(
          (res) => {
            this.slotService.selectedSlotData.selectedDate = new Date();
            if (res) {
              if (res.user?.type && res.user?.type === "B2C") {
                this.isClicked = false;
                this.toastrService.error(
                  "Sorry, '" +
                    this.userLoginForm.controls["username"].value +
                    "' is a customer. Can't login here",
                  null,
                  {
                    timeOut: 2000,
                  }
                );
                return;
              }
              if (res.isSupplier) {
                localStorage.setItem(
                  "isSupplier",
                  JSON.stringify(res.isSupplier)
                );
              }
              // stores token ,userData ,company  details  in localStorage
              this.localStorageService.setUserData(res);

              // stores the businessunits data in which user is part of in localstorage
              // if user is part of default  businessunit ,sets default businessunit as current businessunit else sets first one in the list as current businessunit
              this.localStorageService.postLoginActions(res);

              if (!this.dialogData || res.company) {
                if (res.user.type) {
                  if (window.innerWidth > 600) {
                    this.router.navigateByUrl("/user-homePage");
                  } else {
                    if (this.dialogData && this.dialogData.flag === "slot") {
                      this.router.navigateByUrl("/live-shopping");
                      this.isClosed = false;
                    } else {
                      this.router.navigateByUrl("/business-list");
                    }
                  }
                } else {
                  this.storesService.productsData = [];
                }
              }

              // for b2c user previous cart list and wishlist will be fetched
              if (res.user.type === "B2C") {
                this.cartService.getUserCart().subscribe((userCart) => {
                  if (userCart && userCart.length) {
                    this.slotService.cart = userCart[0].products;
                    localStorage.setItem("cartId", userCart[0]._id);
                  }
                });
              } else {
                // complete data of current businessunit is fetched
                const busUnitIndex = res.businessUnits.businessUnits.findIndex(
                  (each) => each.defaultBusinessUnit
                );
              }
              this.toastrService.success("Login successful", null, {
                timeOut: 2000,
              });
              this.geoCodeService.sessionCount = 0;
              if (!this.storesService.notificationCount) {
                this.slotService
                  .getNotifications(null, null, true)
                  .subscribe((notifications) => {
                    this.storesService.notificationCount = notifications;
                  });
              }
              this.dialogRef.close(true);
            }
          },
          (err) => {
            this.isClicked = false;
            this.toastrService.error(err.error.message, null, {
              timeOut: 2000,
            });
          }
        );
    }
  }
  validUsername() {
    return (
      this.userLoginForm.controls["username"].valid &&
      this.userLoginForm.controls["username"].value.length > 7 &&
      (this.regexService
        .getEmailRegex()
        .test(this.userLoginForm.controls["username"].value) ||
        this.regexService
          .getPhoneRegex()
          .test(this.userLoginForm.controls["username"].value))
    );
  }
  validPassword() {
    return this.userLoginForm.controls["password"].valid;
  }
  validCredentials() {
    return this.validUsername() && this.validPassword() && !this.isClicked;
  }

  register(type) {
    const dil = this.dialogService.openMatDialog(
      RegisterStoreComponent,
      { type },
      false,
      null,
      null,
      true,
      true
    );
    dil.afterClosed().subscribe((res) => {
      if (!res?.backToLogin) {
        this.dialogRef.close();
      }
    });
  }
  backToHome() {
    this.dialogRef.close();
  }

  togglePasswordVisibility() {
    if (this.passwordVisibility) {
      this.passwordVisibility = false;
      this.passwordType = "password";
      this.passwordImg = icons.whiteShopIcon.eyeSlash;
    } else {
      this.passwordVisibility = true;
      this.passwordType = "text";
      this.passwordImg = icons.whiteShopIcon.eye;
    }
    this.passwordField.nativeElement.focus();
  }
  OnClickForgotPassword() {
    this.dialogService.openMatDialog(
      WhiteshopForgotPasswordComponent,
      null,
      true,
      null,
      null,
      true,
      true
    );
  }
}

// Used for login of both B2B
